let seed = 0;

export const uniqueId = (prefix?: string) =>
  prefix ? `${prefix}-${++seed}` : `${++seed}`;
